module.exports = "<div class=\"container\">\r\n  <div class=\"row\"></div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m6\">\r\n\r\n      <app-invoices></app-invoices>\r\n\r\n    </div>\r\n\r\n    <div class=\"col s12 m6\">\r\n\r\n      <app-agreement></app-agreement>\r\n\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/settlements/settlements.component.html
// module id = ../../../../../src/app/pages/dashboard/settlements/settlements.component.html
// module chunks = main